module.exports = __webpack_public_path__ + "static/node-bad3b6cf6b90404a9947b1208f3a156b.png";